export default __webpack_public_path__ + "static/media/kitchen.742a9130.webp";